import { errorStates } from './errorStates';
import { LatestRef } from './types';
import * as codes from './errorCodes';
import get from 'lodash/get';

const knownCodes = Object.values<string>(codes);

export const getPrimaryErrorCode = (ref: LatestRef) => {
  const { amendment, quoteResult, acceptResult } = ref.current;

  if (acceptResult.error) {
    return get(acceptResult.error, 'code', codes.UNEXPECTED) as string;
  }

  if (quoteResult.error) {
    return get(quoteResult.error, 'code', codes.UNEXPECTED) as string;
  }

  if (!amendment) return undefined;

  if (!errorStates.includes(amendment.state)) return undefined;

  const amendmentErrorCodes = amendment.errors?.map(({ code }) => code) ?? [];

  const knownCode = amendmentErrorCodes.find((errorCode) => knownCodes.includes(errorCode));

  if (knownCode) return knownCode;

  if (amendmentErrorCodes[0]) return amendmentErrorCodes[0];

  return codes.UNEXPECTED;
};
